export default {
  "content": "<path d=\"M0 0h32v32H0z\" fill=\"none\"/><path d=\"M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm1 29.95V28h-2v1.95C8.08 29.456 2.543 23.92 2.05 17H4v-2H2.05C2.544 8.08 8.08 2.543 15 2.05V4h2V2.05c6.92.493 12.457 6.03 12.95 12.95H28v2h1.95c-.493 6.92-6.03 12.457-12.95 12.95z\" fill=\"#3F4450\"/><path d=\"M16.136 15.648L8.748 7.335l-1.496 1.33 8 9a1 1 0 001.348.135l8-6-1.2-1.6z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 32 32",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};